import { jsxs, jsx } from 'react/jsx-runtime';
import { Breadcrumbs } from '@tecsinapse/cortex-react';
import { useState } from 'react';
import { getBreadcrumbs } from '../utils/breadcrumbs.js';
import { decorateMenuItems } from '../utils/menu-items.js';
import { calculatePromises } from '../utils/promises.js';
import { useLocation } from 'react-router-dom';
import { Menu } from '../../menubar/ui/index.js';

const Content = ({
  currentProduct,
  productName,
  useReactRouter = false,
  menus,
  routeList,
  linkHelpTec,
  linkPortal,
  linkAcademia,
  currentUser,
  changeUserLanguage,
  brandImageUrl,
  showLanguages = true,
  locales,
  showMyAccount = true,
  logout,
  showOnboarding = false,
  setOnboardingShowed,
  breadcrumbProps,
  showNotifications = true,
  notifications,
  notificationCount,
  onCloseNotifications,
  customOptionsUser
}) => {
  const [loadingBreadcrumb, setLoadingBreadcrumb] = useState(true);
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const {
    pathname
  } = useLocation();
  const [decoratedMenuItems, fallbackRouteList] = decorateMenuItems(useReactRouter, pathname, menus, currentProduct);
  const fallbackRouteListWithRoot = {
    ...fallbackRouteList,
    ...productName.length > 0 ? {
      ROOT: {
        route: "/",
        label: productName
      }
    } : {}
  };
  calculatePromises(setLoadingBreadcrumb, loadingBreadcrumb, setBreadcrumbs, breadcrumbs, getBreadcrumbs(useReactRouter, pathname, routeList || fallbackRouteListWithRoot, breadcrumbProps));
  return /* @__PURE__ */ jsxs("div", { className: "flex flex-col items-center", children: [
    /* @__PURE__ */ jsx(Menu, { brandImageUrl, linkAcademia, showLanguages, changeUserLanguage, linkHelpTec, showNotifications, notificationCount, notifications, linkPortal, currentUser, logout, showMyAccount, decoratedMenuItems, locales, onCloseNotifications, customOptionsUser, setOnboardingShowed, showOnboarding }),
    (breadcrumbs ?? []).length > 0 ? /* @__PURE__ */ jsx("div", { className: "max-w-[1440px] w-[calc(100%-32px)] my-deca mx-auto hidden sm:flex", children: /* @__PURE__ */ jsx(Breadcrumbs, { breadcrumbs }) }) : null
  ] });
};

export { Content };
